// features/config-sistema/api/configSistema.api.js
// Capa de API para configuración del sistema (colores, SMTP, etc.)

import { api } from '../../../api/client';
import { SIZE_PAGINATION, DEFAULT_PAGINATION } from '../../../catalogs/paginado';
export const colorSystemConfigurationsApi = {
  /**
   * Obtiene la configuración activa del sistema (pública, sin token).
   * Esta llamada NO pasa por el cliente centralizado porque se ejecuta
   * antes del login (en SystemContext.jsx).
   * Aquí se expone para uso dentro de componentes autenticados.
   */
  getActive: () => api.get('/system-configuration/istrue'),

  /** Obtiene configuración SMTP */
  getSmtp: () => api.get('/system-configuration/configurationSmtp'),

  /** Lista todas las configuraciones */
  getAll: (data = { page: DEFAULT_PAGINATION.page, size: DEFAULT_PAGINATION.size }) =>
    api.post('/system-configuration/paginated', data),

  search: (dataSearch) => api.post('/system-configuration/search', dataSearch),

  // search: (search) =>
  //   api.post('/system-configuration/search',search),

  /**
   * Crea una configuración
   * @param {object} data
   */
  create: (data) => api.post('/system-configuration', data),

  /**
   * Actualiza una configuración por id
   * @param {string|number} id
   * @param {object} data
   */
  update: (id, data) => api.put(`/system-configuration/${id}`, data),

  /**
   * Elimina una configuración por id
   * @param {string|number} id
   */
  remove: (id) => api.delete(`/system-configuration/${id}`),
};
